module.exports = __webpack_public_path__ + "assets/7ce3b720f31a8555dcdac33d677addfb.png";